/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIBrand } from './APIBrand';
import {
    APIBrandFromJSON,
    APIBrandFromJSONTyped,
    APIBrandToJSON,
} from './APIBrand';

/**
 * 
 * @export
 * @interface APIPaginatedBrandList
 */
export interface APIPaginatedBrandList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedBrandList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedBrandList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedBrandList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIBrand>}
     * @memberof APIPaginatedBrandList
     */
    results: Array<APIBrand>;
}

/**
 * Check if a given object implements the APIPaginatedBrandList interface.
 */
export function instanceOfAPIPaginatedBrandList(value: object): value is APIPaginatedBrandList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedBrandListFromJSON(json: any): APIPaginatedBrandList {
    return APIPaginatedBrandListFromJSONTyped(json, false);
}

export function APIPaginatedBrandListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedBrandList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIBrandFromJSON)),
    };
}

export function APIPaginatedBrandListToJSON(value?: APIPaginatedBrandList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIBrandToJSON)),
    };
}

